import { Ifilter } from "../../Interfaces/filter";
import { fetchListVerificacion } from "../http-common";

const EstadoEquipo = "EstadoEquipo";

const ListarEstado = (request: Ifilter, controller= new AbortController) => {
    return fetchListVerificacion.get(`${EstadoEquipo}`,{
        params: request,
        signal: controller.signal
    });
};

const Combo = (query: Ifilter, controller = new AbortController()) => {
    return fetchListVerificacion.get(`${EstadoEquipo}/Combo`, {
        params: query,
        signal: controller.signal
    });
};
export const EstadoEquipoService = {
    ListarEstado, 
    Combo
}